import { z } from "zod";
//#region src/app-db-credentials.schemas.ts
/**
* Zod schema for the `{appId}--db-credentials` k8s Secret shape (plan §7.6).
* Used by provider-parity tests and the zion-operator consumption check.
*/
const AppDbCredentialsSchema = z.object({
	DATABASE_URL: z.string().min(1),
	DATABASE_SCHEMA: z.string().min(1),
	SEARCH_PATH: z.string().min(1)
}).strict();
//#endregion
export { AppDbCredentialsSchema };

//# sourceMappingURL=app-db-credentials.schemas.js.map